export default "<app-leads-list></app-leads-list>";